/**
 * `components.MuiToggleButton` & `MuiToggleButtonGroup` — text transform and grouped button spacing/borders.
 * Discoverability: `MuiToggleButton`, `ToggleButton`, `ToggleButtonGroup`, `QSegmentedTabs`.
 *
 * @see https://mui.com/material-ui/api/toggle-button/
 * @see https://mui.com/material-ui/api/toggle-button-group/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

import { buttonFocusVisibleStyles } from './buttonFocusTokens';

/** Inset between the group edge and grouped buttons. Inner tab radius = group radius − this. */
export const TOGGLE_BUTTON_GROUP_BUTTON_MARGIN_PX = 2;

const groupedButtonLayout = {
  borderStyle: 'hidden',
  borderRadius: 'inherit',
  margin: TOGGLE_BUTTON_GROUP_BUTTON_MARGIN_PX,
} as const;

export function muiToggle(theme: Theme): Pick<Components<Theme>, 'MuiToggleButton' | 'MuiToggleButtonGroup'> {
  return {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          '&.Mui-focusVisible': buttonFocusVisibleStyles(theme),
        },
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        firstButton: groupedButtonLayout,
        middleButton: groupedButtonLayout,
        lastButton: groupedButtonLayout,
      },
    },
  };
}
